import { TabsNav, TabsNavLink } from "@qw/ui";
import { Outlet } from "react-router";
import { AppNav } from "@/app/app-nav";
import { ResizableChatLayout } from "@/chat/resizable-chat-layout";
import { NewPlaybookButton } from "./new-playbook-button";

export const PlaybooksLayout = () => (
  <>
    <AppNav>
      <NewPlaybookButton />
      <TabsNav className="absolute left-1/2 top-1/2 -translate-1/2">
        <TabsNavLink to="/playbooks" end>
          Active
        </TabsNavLink>
        <TabsNavLink to="/playbooks/discover">Discover</TabsNavLink>
        <TabsNavLink to="/playbooks/triggers">Triggers</TabsNavLink>
        <TabsNavLink to="/playbooks/runs">Runs</TabsNavLink>
      </TabsNav>
    </AppNav>
    <main className="flex flex-auto overflow-hidden">
      <ResizableChatLayout autoSaveId="playbooks-chat-panels">
        <Outlet />
      </ResizableChatLayout>
    </main>
  </>
);
